module.exports = __webpack_public_path__ + "img/J38-algeria.58a20db3.png";